/* ==========================================================================
   QUESTION BANK — PART 2: CLINICAL & NURSING
   All items original, written against each exam's published blueprint.
   Appends to window.XP_BANK.items created by exam-bank.js.
   ========================================================================== */
(function () {
  'use strict';

  if (!window.XP_BANK) window.XP_BANK = { items: [], stimuli: {} };
  var items = window.XP_BANK.items;

  var R = {
    statpearls: { t: 'StatPearls (NCBI Bookshelf) — peer-reviewed clinical reference', u: 'https://www.ncbi.nlm.nih.gov/books/NBK430685/', k: 'scholarly' },
    openstaxAP: { t: 'OpenStax — Anatomy & Physiology 2e', u: 'https://openstax.org/details/books/anatomy-and-physiology-2e', k: 'scholarly' },
    openstaxBio: { t: 'OpenStax — Biology 2e', u: 'https://openstax.org/details/books/biology-2e', k: 'scholarly' },
    openstaxChem: { t: 'OpenStax — Chemistry 2e', u: 'https://openstax.org/details/books/chemistry-2e', k: 'scholarly' },
    cdcPrecautions: { t: 'CDC — Standard & Transmission-Based Precautions', u: 'https://www.cdc.gov/infection-control/hcp/basics/standard-precautions.html', k: 'scholarly' },
    cdcHand: { t: 'CDC — Hand Hygiene in Healthcare Settings', u: 'https://www.cdc.gov/clean-hands/hcp/clinical-safety/', k: 'scholarly' },
    ncbiBook: { t: 'NCBI Bookshelf — open-access biomedical texts', u: 'https://www.ncbi.nlm.nih.gov/books/', k: 'scholarly' },
    ahaCpr: { t: 'American Heart Association — CPR & ECC Guidelines', u: 'https://cpr.heart.org/en/resuscitation-science/cpr-and-ecc-guidelines', k: 'scholarly' },
    clsi: { t: 'NCBI — Phlebotomy specimen collection review', u: 'https://www.ncbi.nlm.nih.gov/books/NBK441910/', k: 'scholarly' }
  };
  function yt(q, label) {
    return { t: label || ('YouTube — ' + q), u: 'https://www.youtube.com/results?search_query=' + encodeURIComponent(q), k: 'video' };
  }

  /* ---- shared SVG helpers ---------------------------------------------- */
  var SVG_HEAD = '<svg viewBox="0 0 460 240" xmlns="http://www.w3.org/2000/svg" role="img">';

  var svgOrderOfDraw =
    SVG_HEAD +
    '<style>.lbl{font:600 11px sans-serif;fill:#1d2b2a}.cap{font:11px sans-serif;fill:#63807d}</style>' +
    '<rect x="10" y="40" width="60" height="90" rx="6" fill="#fff" stroke="#7a8b99" stroke-width="2"/>' +
    '<rect x="10" y="40" width="60" height="16" rx="6" fill="#8fa3b0"/>' +
    '<text class="lbl" x="40" y="150" text-anchor="middle">1. Blood</text>' +
    '<text class="cap" x="40" y="164" text-anchor="middle">culture</text>' +
    '<rect x="90" y="40" width="60" height="90" rx="6" fill="#fff" stroke="#3a7bd5" stroke-width="2"/>' +
    '<rect x="90" y="40" width="60" height="16" rx="6" fill="#3a7bd5"/>' +
    '<text class="lbl" x="120" y="150" text-anchor="middle">2. Light</text>' +
    '<text class="cap" x="120" y="164" text-anchor="middle">blue (citrate)</text>' +
    '<rect x="170" y="40" width="60" height="90" rx="6" fill="#fff" stroke="#c9a227" stroke-width="2"/>' +
    '<rect x="170" y="40" width="60" height="16" rx="6" fill="#c9a227"/>' +
    '<text class="lbl" x="200" y="150" text-anchor="middle">3. Gold /</text>' +
    '<text class="cap" x="200" y="164" text-anchor="middle">red (serum)</text>' +
    '<rect x="250" y="40" width="60" height="90" rx="6" fill="#fff" stroke="#1b7f52" stroke-width="2"/>' +
    '<rect x="250" y="40" width="60" height="16" rx="6" fill="#1b7f52"/>' +
    '<text class="lbl" x="280" y="150" text-anchor="middle">4. Green</text>' +
    '<text class="cap" x="280" y="164" text-anchor="middle">(heparin)</text>' +
    '<rect x="330" y="40" width="60" height="90" rx="6" fill="#fff" stroke="#7b3fa0" stroke-width="2"/>' +
    '<rect x="330" y="40" width="60" height="16" rx="6" fill="#7b3fa0"/>' +
    '<text class="lbl" x="360" y="150" text-anchor="middle">5. Lavender</text>' +
    '<text class="cap" x="360" y="164" text-anchor="middle">(EDTA)</text>' +
    '<rect x="410" y="40" width="40" height="90" rx="6" fill="#fff" stroke="#8a8f98" stroke-width="2"/>' +
    '<rect x="410" y="40" width="40" height="16" rx="6" fill="#8a8f98"/>' +
    '<text class="lbl" x="430" y="150" text-anchor="middle">6. Grey</text>' +
    '<text class="cap" x="230" y="200" text-anchor="middle">Additive carryover between tubes is what the order prevents.</text>' +
    '<text class="cap" x="230" y="218" text-anchor="middle">Draw left to right, every time.</text>' +
    '<text class="lbl" x="230" y="25" text-anchor="middle">CLSI order of draw</text>' +
    '</svg>';

  var svgNephron =
    '<svg viewBox="0 0 440 260" xmlns="http://www.w3.org/2000/svg" role="img">' +
    '<style>.l{font:600 11px sans-serif;fill:#1d2b2a}.c{font:10px sans-serif;fill:#63807d}</style>' +
    '<circle cx="70" cy="60" r="26" fill="#ffe0e0" stroke="#b3261e" stroke-width="2"/>' +
    '<text class="l" x="70" y="63" text-anchor="middle">GLOM</text>' +
    '<text class="c" x="70" y="102" text-anchor="middle">Filtration</text>' +
    '<path d="M96 60 H150 V150 H190" fill="none" stroke="#004B49" stroke-width="3"/>' +
    '<text class="l" x="150" y="52" text-anchor="middle">PCT</text>' +
    '<text class="c" x="150" y="128" text-anchor="middle">65% Na+ reabsorbed</text>' +
    '<path d="M190 150 V210 H240 V150" fill="none" stroke="#004B49" stroke-width="3"/>' +
    '<text class="l" x="215" y="232" text-anchor="middle">Loop of Henle</text>' +
    '<text class="c" x="215" y="246" text-anchor="middle">loop diuretics act here</text>' +
    '<path d="M240 150 H300 V80 H360" fill="none" stroke="#004B49" stroke-width="3"/>' +
    '<text class="l" x="300" y="70" text-anchor="middle">DCT</text>' +
    '<text class="c" x="300" y="140" text-anchor="middle">thiazides act here</text>' +
    '<path d="M360 80 V200" fill="none" stroke="#7b3fa0" stroke-width="3"/>' +
    '<text class="l" x="395" y="140" text-anchor="middle">Collecting</text>' +
    '<text class="c" x="395" y="155" text-anchor="middle">duct — ADH,</text>' +
    '<text class="c" x="395" y="169" text-anchor="middle">aldosterone</text>' +
    '<text class="c" x="360" y="218" text-anchor="middle">to urine</text>' +
    '</svg>';

  var svgAcidBase =
    '<svg viewBox="0 0 440 220" xmlns="http://www.w3.org/2000/svg" role="img">' +
    '<style>.h{font:700 12px sans-serif;fill:#1d2b2a}.l{font:600 11px sans-serif;fill:#1d2b2a}.c{font:10px sans-serif;fill:#63807d}</style>' +
    '<text class="h" x="220" y="20" text-anchor="middle">Reading an ABG in three steps</text>' +
    '<rect x="15" y="35" width="130" height="70" rx="8" fill="#f2faf8" stroke="#c8e0de"/>' +
    '<text class="l" x="80" y="55" text-anchor="middle">1. pH</text>' +
    '<text class="c" x="80" y="72" text-anchor="middle">&lt;7.35 acidosis</text>' +
    '<text class="c" x="80" y="88" text-anchor="middle">&gt;7.45 alkalosis</text>' +
    '<rect x="155" y="35" width="130" height="70" rx="8" fill="#f2faf8" stroke="#c8e0de"/>' +
    '<text class="l" x="220" y="55" text-anchor="middle">2. PaCO2</text>' +
    '<text class="c" x="220" y="72" text-anchor="middle">moves WITH pH?</text>' +
    '<text class="c" x="220" y="88" text-anchor="middle">no → respiratory</text>' +
    '<rect x="295" y="35" width="130" height="70" rx="8" fill="#f2faf8" stroke="#c8e0de"/>' +
    '<text class="l" x="360" y="55" text-anchor="middle">3. HCO3-</text>' +
    '<text class="c" x="360" y="72" text-anchor="middle">moves WITH pH?</text>' +
    '<text class="c" x="360" y="88" text-anchor="middle">yes → metabolic</text>' +
    '<rect x="15" y="125" width="410" height="80" rx="8" fill="#fff" stroke="#c8e0de"/>' +
    '<text class="l" x="30" y="147">ROME</text>' +
    '<text class="c" x="30" y="166">Respiratory Opposite — pH and CO2 move in opposite directions</text>' +
    '<text class="c" x="30" y="184">Metabolic Equal — pH and HCO3- move in the same direction</text>' +
    '</svg>';

  var svgHeartConduction =
    '<svg viewBox="0 0 420 250" xmlns="http://www.w3.org/2000/svg" role="img">' +
    '<style>.l{font:600 11px sans-serif;fill:#1d2b2a}.c{font:10px sans-serif;fill:#63807d}</style>' +
    '<path d="M210 25 C120 25 70 95 90 155 C108 208 175 232 210 232 C245 232 312 208 330 155 C350 95 300 25 210 25 Z" fill="#ffeef0" stroke="#b3261e" stroke-width="2"/>' +
    '<circle cx="150" cy="70" r="9" fill="#c9a227"/>' +
    '<text class="l" x="150" y="55" text-anchor="middle">SA node</text>' +
    '<text class="c" x="150" y="95" text-anchor="middle">60-100 bpm</text>' +
    '<circle cx="210" cy="130" r="9" fill="#1b7f52"/>' +
    '<text class="l" x="255" y="128">AV node</text>' +
    '<text class="c" x="255" y="143">40-60 bpm</text>' +
    '<path d="M150 79 Q180 105 210 121" fill="none" stroke="#004B49" stroke-width="2" stroke-dasharray="4 3"/>' +
    '<path d="M210 139 V175" stroke="#004B49" stroke-width="3"/>' +
    '<text class="c" x="238" y="170">Bundle of His</text>' +
    '<path d="M210 175 L165 215 M210 175 L255 215" stroke="#004B49" stroke-width="3"/>' +
    '<text class="c" x="150" y="228" text-anchor="middle">Purkinje 20-40</text>' +
    '<text class="l" x="210" y="16" text-anchor="middle">Cardiac conduction &amp; intrinsic rates</text>' +
    '</svg>';

  /* =====================================================================
     HESI A2
     ===================================================================== */
  items.push(
    {
      id: 'hesi-ap-01', exam: 'hesi', section: 'anatomy', difficulty: 'moderate', type: 'mcq',
      q: 'Which structure prevents backflow of blood from the left ventricle into the left atrium during ventricular systole?',
      opts: ['Tricuspid valve', 'Mitral (bicuspid) valve', 'Aortic semilunar valve', 'Pulmonic valve'],
      a: 1,
      why: '<p>The <strong>mitral valve</strong> sits between the left atrium and left ventricle. When the ventricle contracts, pressure slams it shut — that is the <em>first</em> heart sound, S1.</p>' +
        '<p>Sort the four valves by the chamber pair they separate:</p>' +
        '<ul><li><strong>Tricuspid</strong> — right atrium to right ventricle</li>' +
        '<li><strong>Mitral</strong> — left atrium to left ventricle</li>' +
        '<li><strong>Pulmonic</strong> — right ventricle to pulmonary artery</li>' +
        '<li><strong>Aortic</strong> — left ventricle to aorta</li></ul>' +
        '<p>The semilunar valves (aortic, pulmonic) guard the exits, not the atrial openings, so neither can prevent atrial backflow.</p>',
      refs: [R.openstaxAP, yt('heart valves blood flow anatomy animation', 'Video — Blood flow through the heart')]
    },
    {
      id: 'hesi-ap-02', exam: 'hesi', section: 'anatomy', difficulty: 'hard', type: 'mcq',
      q: 'Loop diuretics such as furosemide produce a stronger diuresis than thiazides primarily because they act on a segment that reabsorbs:',
      opts: [
        'A larger fraction of filtered sodium',
        'All of the filtered glucose',
        'Potassium exclusively',
        'Water without any solute'
      ],
      a: 0,
      why: '<p>The thick ascending limb of the loop of Henle reabsorbs roughly <strong>25% of filtered sodium</strong>; the distal convoluted tubule, where thiazides act, handles only about <strong>5%</strong>. Blocking the bigger site produces the bigger diuresis — which is why loop diuretics are called "high-ceiling".</p>' +
        '<p>Glucose is reabsorbed almost entirely in the proximal tubule, and no segment moves water without solute — water follows osmotic gradients created by solute movement.</p>',
      visual: svgNephron, caption: 'Where each diuretic class acts along the nephron.',
      refs: [R.statpearls, yt('nephron diuretics site of action pharmacology', 'Video — Diuretics by nephron segment')]
    },
    {
      id: 'hesi-chem-01', exam: 'hesi', section: 'chemistry', difficulty: 'moderate', type: 'mcq',
      q: 'An atom of an element has 17 protons, 18 neutrons and 17 electrons. What is its mass number and charge?',
      opts: ['Mass 17, charge 0', 'Mass 35, charge 0', 'Mass 35, charge −1', 'Mass 52, charge 0'],
      a: 1,
      why: '<p><strong>Mass number = protons + neutrons</strong> = 17 + 18 = <strong>35</strong>. Electrons have negligible mass and are not counted.</p>' +
        '<p>Charge = protons − electrons = 17 − 17 = <strong>0</strong>, so the atom is neutral.</p>' +
        '<p>Common traps: 17 is the <em>atomic</em> number, not the mass number; 52 comes from wrongly adding electrons too; and a −1 charge would require 18 electrons, which would make this the chloride ion rather than a chlorine atom.</p>',
      refs: [R.openstaxChem, yt('atomic number mass number ions explained', 'Video — Atomic number vs mass number')]
    },
    {
      id: 'hesi-math-01', exam: 'hesi', section: 'math', difficulty: 'moderate', type: 'entry',
      q: 'A solution is 0.9% sodium chloride by mass. How many grams of NaCl are in 500 mL? (Assume 1 mL = 1 g. Give the number of grams.)',
      a: 4.5, tol: 0.01,
      why: '<p>0.9% means 0.9 g per 100 mL. Scale to 500 mL:</p>' +
        '<p>500 ÷ 100 = 5, and 5 × 0.9 = <strong>4.5 g</strong>.</p>' +
        '<p>The reliable habit here is treating percentage strength as "grams per 100 mL" rather than converting to decimals first — it removes the most common slip, which is answering 0.45 g (dividing when you should multiply) or 45 g (misplacing the decimal by a factor of ten).</p>',
      refs: [yt('percentage solution concentration nursing math', 'Video — Percentage strength calculations')]
    },
    {
      id: 'hesi-bio-01', exam: 'hesi', section: 'biology', difficulty: 'moderate', type: 'mcq',
      q: 'During which phase of mitosis do sister chromatids separate and move toward opposite poles?',
      opts: ['Prophase', 'Metaphase', 'Anaphase', 'Telophase'],
      a: 2,
      why: '<p><strong>Anaphase</strong> is defined by separation — the centromeres split and sister chromatids are pulled apart.</p>' +
        '<p>The sequence is easiest to hold by what each phase <em>looks</em> like:</p>' +
        '<ul><li><strong>Prophase</strong> — chromatin condenses, nuclear envelope breaks down</li>' +
        '<li><strong>Metaphase</strong> — chromosomes line up on the middle plate</li>' +
        '<li><strong>Anaphase</strong> — chromatids move apart</li>' +
        '<li><strong>Telophase</strong> — two nuclei re-form; cytokinesis divides the cytoplasm</li></ul>',
      refs: [R.openstaxBio, yt('mitosis phases animation prophase anaphase', 'Video — The phases of mitosis')]
    },
    {
      id: 'hesi-gram-01', exam: 'hesi', section: 'vocab', difficulty: 'moderate', type: 'mcq',
      q: 'Choose the sentence with correct pronoun case.',
      opts: [
        'The charge nurse assigned the admission to Marcus and I.',
        'The charge nurse assigned the admission to Marcus and me.',
        'Marcus and me completed the admission together.',
        'Her and Marcus completed the admission together.'
      ],
      a: 1,
      why: '<p>"To" is a preposition, so it takes the <strong>objective</strong> case: <em>me</em>, not <em>I</em>.</p>' +
        '<p>The test that never fails is to delete the other person: "assigned the admission to <s>Marcus and</s> me" sounds right; "to I" does not.</p>' +
        '<p>Options C and D fail the same test in reverse — they need subject pronouns: "Marcus and <strong>I</strong> completed", "<strong>She</strong> and Marcus completed".</p>',
      refs: [{ t: 'Purdue OWL — Pronoun case', u: 'https://owl.purdue.edu/owl/general_writing/grammar/pronouns.html', k: 'reference' }]
    },

    /* =====================================================================
       NCLEX-RN
       ===================================================================== */
    {
      id: 'nclex-saf-01', exam: 'nclex-rn', section: 'safe-care', difficulty: 'moderate', type: 'mcq',
      q: 'A nurse is caring for four clients. Which should be assessed FIRST?',
      opts: [
        'A client with a fractured femur reporting pain rated 7 of 10',
        'A client two days post-op reporting sudden shortness of breath',
        'A client with type 2 diabetes whose morning glucose is 168 mg/dL',
        'A client awaiting discharge who has questions about medications'
      ],
      a: 1,
      why: '<p>Sudden dyspnoea two days after surgery suggests <strong>pulmonary embolism</strong> — an airway/breathing problem that can kill within minutes. <strong>ABCs come before pain, before glucose, before teaching.</strong></p>' +
        '<p>Why the others wait: pain of 7/10 is urgent but not life-threatening; 168 mg/dL is elevated but not a crisis; discharge teaching is important and entirely non-urgent.</p>' +
        '<p>On prioritisation items, ask "which of these could stop breathing or lose a pulse in the next few minutes?" — and beware the plausible-sounding <em>new, sudden</em> symptom, which is almost always the answer.</p>',
      refs: [R.statpearls, yt('NCLEX prioritization ABC Maslow nursing', 'Video — Prioritisation frameworks for NCLEX')]
    },
    {
      id: 'nclex-pharm-01', exam: 'nclex-rn', section: 'physiological', difficulty: 'hard', type: 'mcq',
      q: 'A client on digoxin has a serum potassium of 2.9 mEq/L. The nurse recognises that this places the client at greatest risk for:',
      opts: [
        'Reduced digoxin effect requiring a higher dose',
        'Digoxin toxicity',
        'Hypertensive crisis',
        'Increased renal clearance of digoxin'
      ],
      a: 1,
      why: '<p><strong>Hypokalaemia potentiates digoxin.</strong> Digoxin and potassium compete for the same binding site on the Na⁺/K⁺-ATPase pump. When potassium is low, more digoxin binds — so a "normal" serum digoxin level can still produce full-blown toxicity.</p>' +
        '<p>Watch for anorexia, nausea, visual disturbance (classically yellow-green halos) and new dysrhythmias. Normal potassium is 3.5–5.0 mEq/L, so 2.9 is meaningfully low.</p>' +
        '<p>This pairing — a drug plus an electrolyte — is a favourite item type. Digoxin + low K⁺, lithium + low Na⁺, and warfarin + vitamin K are the three worth memorising cold.</p>',
      refs: [R.statpearls, yt('digoxin toxicity hypokalemia mechanism nursing', 'Video — Digoxin and potassium')]
    },
    {
      id: 'nclex-med-01', exam: 'nclex-rn', section: 'physiological', difficulty: 'hard', type: 'mcq',
      q: 'An arterial blood gas shows pH 7.28, PaCO₂ 58 mm Hg, HCO₃⁻ 25 mEq/L. This represents:',
      opts: [
        'Metabolic acidosis, uncompensated',
        'Respiratory acidosis, uncompensated',
        'Respiratory alkalosis, partially compensated',
        'Metabolic alkalosis, fully compensated'
      ],
      a: 1,
      why: '<p>Work it in three steps. <strong>pH 7.28</strong> is below 7.35, so acidosis. <strong>PaCO₂ 58</strong> is above the normal 35–45 and moves <em>opposite</em> to pH — that makes it respiratory. <strong>HCO₃⁻ 25</strong> is normal (22–26), so the kidneys have not started compensating yet: uncompensated.</p>' +
        '<p>ROME is the shortcut: <strong>R</strong>espiratory <strong>O</strong>pposite, <strong>M</strong>etabolic <strong>E</strong>qual. Here pH went down while CO₂ went up — opposite directions, therefore respiratory.</p>' +
        '<p>Clinically this is hypoventilation: opioid oversedation, COPD exacerbation, or a neuromuscular problem.</p>',
      visual: svgAcidBase, caption: 'The three-step ABG method, and the ROME mnemonic.',
      refs: [R.statpearls, yt('ABG interpretation ROME method nursing', 'Video — ABG interpretation with ROME')]
    },
    {
      id: 'nclex-mat-01', exam: 'nclex-rn', section: 'health-promo', difficulty: 'moderate', type: 'mcq',
      q: 'A labouring client\'s membranes rupture and the fetal heart rate immediately drops to 90 bpm with variable decelerations. The nurse\'s FIRST action is to:',
      opts: [
        'Notify the healthcare provider',
        'Reposition the client to knee-chest or Trendelenburg',
        'Document the finding and continue monitoring',
        'Prepare the client for immediate caesarean section'
      ],
      a: 1,
      why: '<p>Rupture of membranes followed immediately by variable decelerations and bradycardia points to <strong>cord prolapse or compression</strong>. The first action is a nursing action that relieves the pressure: <strong>reposition</strong> to knee-chest or Trendelenburg to shift the presenting part off the cord.</p>' +
        '<p>Notifying the provider comes next, and caesarean may well follow — but the nurse acts before calling. Documentation is never the first action in an emergency.</p>' +
        '<p>The rule this tests: when the question asks what the nurse does <em>first</em> and a nursing intervention will directly relieve the problem, do it before you delegate or call.</p>',
      refs: [R.statpearls, yt('umbilical cord prolapse nursing interventions', 'Video — Cord prolapse management')]
    },
    {
      id: 'nclex-psych-01', exam: 'nclex-rn', section: 'psychosocial', difficulty: 'moderate', type: 'mcq',
      q: 'A client says, "I have decided to stop taking my medication because I feel completely fine now." The most therapeutic response is:',
      opts: [
        '"You really should not stop — you will relapse."',
        '"Why would you do that after everything we have worked on?"',
        '"Tell me more about what feeling fine has been like for you."',
        '"I will let the doctor know you are refusing treatment."'
      ],
      a: 2,
      why: '<p>Option C is an <strong>open-ended invitation to explore</strong> — it keeps the client talking, gathers the reasoning behind the decision, and preserves the relationship. That is what therapeutic communication items reward.</p>' +
        '<p>Why the others fail: A gives advice and warns; B begins with "why", which puts the client on the defensive and demands justification; D is punitive and reports rather than engages.</p>' +
        '<p>Screening heuristic for these items: eliminate anything that advises, reassures falsely, asks "why", or shuts the conversation down. The answer is nearly always the response that opens it up.</p>',
      refs: [yt('therapeutic communication techniques nursing NCLEX', 'Video — Therapeutic communication')]
    },
    {
      id: 'nclex-del-01', exam: 'nclex-rn', section: 'safe-care', difficulty: 'hard', type: 'mcq',
      q: 'Which task may the registered nurse appropriately delegate to unlicensed assistive personnel (UAP)?',
      opts: [
        'Assessing a new admission\'s skin integrity',
        'Reinforcing previously taught crutch-walking technique',
        'Evaluating a client\'s response to a new antihypertensive',
        'Ambulating a stable post-operative client and reporting the distance walked'
      ],
      a: 3,
      why: '<p>UAP may perform <strong>standard, predictable tasks on stable clients</strong>. Ambulating a stable post-op client and reporting a measurable observation fits exactly.</p>' +
        '<p>The three verbs that can never be delegated are <strong>assess, evaluate and teach</strong> — plus anything requiring nursing judgement. Option A assesses, C evaluates, B teaches (reinforcing teaching still belongs to licensed staff).</p>' +
        '<p>The "five rights of delegation" — right task, circumstance, person, direction and supervision — are the framework the exam grades against.</p>',
      refs: [{ t: 'NCSBN — National Guidelines for Nursing Delegation', u: 'https://www.ncsbn.org/public-files/NGND-PosPaper_06.pdf', k: 'scholarly' }, yt('delegation nursing UAP LPN RN NCLEX', 'Video — Delegation rules')]
    },

    /* =====================================================================
       DOSAGE CALCULATION
       ===================================================================== */
    {
      id: 'dose-01', exam: 'dosage-calculation', section: 'oral', difficulty: 'easy', type: 'entry',
      q: 'The order is 375 mg of an oral suspension. The bottle is labelled 250 mg per 5 mL. How many millilitres should be given?',
      a: 7.5, tol: 0.05,
      why: '<p>Desired over have, times the vehicle:</p>' +
        '<p>(375 mg ÷ 250 mg) × 5 mL = 1.5 × 5 = <strong>7.5 mL</strong></p>' +
        '<p>Sanity check before you draw it up: 375 is one and a half times 250, so the volume must be one and a half times 5 mL. If your answer is not near 7.5, the ratio was inverted.</p>',
      refs: [yt('desired over have dosage calculation nursing', 'Video — Desired over Have method')]
    },
    {
      id: 'dose-02', exam: 'dosage-calculation', section: 'weight', difficulty: 'hard', type: 'entry',
      q: 'An order reads 12 mg/kg/day divided every 8 hours for a child weighing 33 lb. How many milligrams should each individual dose contain?',
      a: 60, tol: 0.5,
      why: '<p>Three steps, in this order:</p>' +
        '<p><strong>1. Convert weight.</strong> 33 lb ÷ 2.2 = 15 kg</p>' +
        '<p><strong>2. Daily dose.</strong> 15 kg × 12 mg = 180 mg per day</p>' +
        '<p><strong>3. Divide by frequency.</strong> Every 8 hours = 3 doses per day. 180 ÷ 3 = <strong>60 mg per dose</strong></p>' +
        '<p>The classic error is stopping at 180 mg and giving the whole daily dose at once. "Divided every 8 hours" always means the total is split, never repeated.</p>',
      refs: [yt('pediatric weight based dosage calculation mg kg day', 'Video — Weight-based paediatric dosing')]
    },
    {
      id: 'dose-03', exam: 'dosage-calculation', section: 'iv', difficulty: 'moderate', type: 'entry',
      q: 'Infuse 1,000 mL over 8 hours using tubing with a drop factor of 15 gtt/mL. What is the flow rate in drops per minute?',
      a: 31, tol: 1,
      why: '<p>Formula: (volume ÷ time in minutes) × drop factor</p>' +
        '<p>8 hours = 480 minutes. 1,000 ÷ 480 = 2.083 mL/min. 2.083 × 15 = 31.25, rounded to <strong>31 gtt/min</strong>.</p>' +
        '<p>Drops are always rounded to a whole number — you cannot deliver a fraction of a drop. Note the difference from an electronic pump, which is programmed in mL/hr (here, 125 mL/hr).</p>',
      refs: [yt('IV drip rate gtt per minute calculation drop factor', 'Video — Drip rate calculations')]
    },
    {
      id: 'dose-04', exam: 'dosage-calculation', section: 'iv', difficulty: 'advanced', type: 'entry',
      q: 'Heparin 25,000 units in 250 mL is ordered at 850 units/hour. At what rate should the pump be set, in mL/hour?',
      a: 8.5, tol: 0.1,
      why: '<p>First find the concentration: 25,000 units ÷ 250 mL = <strong>100 units/mL</strong>.</p>' +
        '<p>Then divide the ordered rate by the concentration: 850 units/hr ÷ 100 units/mL = <strong>8.5 mL/hr</strong>.</p>' +
        '<p>Heparin is a high-alert medication — this calculation is independently double-checked by a second nurse in most facilities, and the exam expects you to know that.</p>',
      refs: [R.statpearls, yt('heparin drip rate calculation units per hour', 'Video — Heparin infusion rates')]
    },

    /* =====================================================================
       NREMT
       ===================================================================== */
    {
      id: 'nremt-air-01', exam: 'nremt', section: 'airway', difficulty: 'moderate', type: 'mcq',
      q: 'An unresponsive adult has snoring respirations. There is no suspicion of spinal injury. The FIRST action is to:',
      opts: [
        'Insert an oropharyngeal airway',
        'Perform a head-tilt chin-lift',
        'Begin bag-valve-mask ventilation',
        'Apply a non-rebreather mask at 15 L/min'
      ],
      a: 1,
      why: '<p>Snoring means the <strong>tongue is obstructing the airway</strong>. The simplest, fastest, no-equipment fix is a <strong>manual repositioning manoeuvre</strong> — head-tilt chin-lift when there is no spinal concern, jaw thrust when there is.</p>' +
        '<p>An oropharyngeal airway is reasonable but comes <em>after</em> manual positioning. Oxygen and ventilation are useless if the airway is still blocked.</p>' +
        '<p>The rule is positional first, adjunct second, ventilation third — in that order, every time.</p>',
      refs: [R.ahaCpr, yt('head tilt chin lift jaw thrust airway EMT', 'Video — Manual airway manoeuvres')]
    },
    {
      id: 'nremt-tra-01', exam: 'nremt', section: 'trauma', difficulty: 'hard', type: 'mcq',
      q: 'A patient thrown from a motorcycle has cool, pale skin, a pulse of 128, and a blood pressure of 118/96. These findings are most consistent with:',
      opts: [
        'Neurogenic shock',
        'Compensated hypovolaemic shock',
        'Decompensated hypovolaemic shock',
        'No shock — vital signs are within normal limits'
      ],
      a: 1,
      why: '<p>The systolic is still normal, which makes this <strong>compensated</strong> shock — but the body is working hard to keep it there. The tells are <strong>tachycardia</strong>, <strong>cool pale skin</strong> from peripheral vasoconstriction, and a <strong>narrowing pulse pressure</strong> (118 − 96 = 22; normal is 30–40).</p>' +
        '<p>Waiting for hypotension is the trap. By the time systolic falls, roughly 30% of blood volume is already gone and the patient has decompensated.</p>' +
        '<p>Neurogenic shock is the opposite picture: warm, dry, flushed skin with <em>bradycardia</em>, because sympathetic tone is lost.</p>',
      refs: [R.statpearls, yt('compensated vs decompensated shock EMT signs', 'Video — Stages of shock')]
    },
    {
      id: 'nremt-car-01', exam: 'nremt', section: 'cardiology', difficulty: 'moderate', type: 'mcq',
      q: 'During adult CPR with two rescuers and an advanced airway in place, ventilations should be delivered:',
      opts: [
        'At a 30:2 ratio with pauses for compressions',
        'Every 6 seconds without pausing compressions',
        'Every 2 seconds continuously',
        'Only when the patient shows spontaneous movement'
      ],
      a: 1,
      why: '<p>Once an advanced airway is placed, compressions become <strong>continuous</strong> and ventilations are given <strong>once every 6 seconds</strong> — about 10 breaths per minute — without interrupting compressions.</p>' +
        '<p>The 30:2 ratio applies only <em>before</em> an advanced airway. Every pause in compressions drops coronary perfusion pressure, and it takes several compressions to build it back, so minimising interruptions is the single highest-value thing a rescuer does.</p>' +
        '<p>Every 2 seconds would be 30 breaths per minute — severe hyperventilation, which raises intrathoracic pressure and reduces venous return.</p>',
      refs: [R.ahaCpr, yt('CPR advanced airway ventilation rate every 6 seconds', 'Video — CPR with an advanced airway')]
    },
    {
      id: 'nremt-med-01', exam: 'nremt', section: 'medical', difficulty: 'moderate', type: 'mcq',
      q: 'A diabetic patient is confused, diaphoretic and tachycardic, with a blood glucose of 42 mg/dL. The patient can follow commands and swallow. The appropriate treatment is:',
      opts: [
        'Withhold anything by mouth and transport',
        'Administer oral glucose',
        'Administer insulin',
        'Give a large drink of water'
      ],
      a: 1,
      why: '<p>42 mg/dL is <strong>hypoglycaemia</strong>. Because the patient has an intact gag reflex and can swallow, <strong>oral glucose</strong> is both safe and immediate.</p>' +
        '<p>Insulin would be actively harmful — it lowers glucose further. Water treats nothing. Withholding treatment wastes the window in which brain injury is preventable.</p>' +
        '<p>The safety gate to remember: give nothing by mouth if the patient cannot protect their own airway. An unresponsive hypoglycaemic patient needs IV dextrose or IM glucagon instead.</p>',
      refs: [R.statpearls, yt('hypoglycemia EMT oral glucose treatment', 'Video — Prehospital hypoglycaemia')]
    },

    /* =====================================================================
       PHLEBOTOMY
       ===================================================================== */
    {
      id: 'phleb-01', exam: 'phlebotomy', section: 'collection', difficulty: 'moderate', type: 'mcq',
      q: 'A coagulation study (light blue top) and a CBC (lavender top) are both ordered. In what order should the tubes be drawn?',
      opts: [
        'Lavender first, then light blue',
        'Light blue first, then lavender',
        'Either order — additives do not interact',
        'Draw a discard tube, then lavender, then light blue'
      ],
      a: 1,
      why: '<p>CLSI order of draw puts <strong>light blue (sodium citrate) before lavender (EDTA)</strong>.</p>' +
        '<p>The reason is carryover. EDTA binds calcium and contains potassium — even a trace transferred into a citrate tube will falsely prolong clotting times and skew potassium results. Additives can contaminate forward but not backward, which is why the sequence is fixed.</p>' +
        '<p>Full order: blood cultures → light blue → gold/red (serum) → green (heparin) → lavender (EDTA) → grey.</p>',
      visual: svgOrderOfDraw, caption: 'The CLSI order of draw. Sequence exists to prevent additive carryover.',
      refs: [R.clsi, yt('order of draw phlebotomy tubes CLSI mnemonic', 'Video — Order of draw explained')]
    },
    {
      id: 'phleb-02', exam: 'phlebotomy', section: 'handling', difficulty: 'moderate', type: 'mcq',
      q: 'A patient\'s potassium result is markedly elevated but the patient has no symptoms and normal renal function. The most likely pre-analytical cause is:',
      opts: [
        'Haemolysis of the specimen',
        'Under-filling the tube',
        'Drawing from the non-dominant arm',
        'Using a 21-gauge needle'
      ],
      a: 0,
      why: '<p>Potassium sits mainly <em>inside</em> red cells. When cells rupture — <strong>haemolysis</strong> — that intracellular potassium spills into the serum and the result reads falsely high.</p>' +
        '<p>Common causes: too small a needle, vigorous shaking rather than gentle inversion, prolonged tourniquet time, or forcing blood through a needle into a tube.</p>' +
        '<p>Under-filling matters for citrate tubes (it changes the blood-to-additive ratio), not for potassium. A 21-gauge needle is the standard size. Arm choice is irrelevant.</p>',
      refs: [R.clsi, yt('hemolysis causes phlebotomy potassium falsely elevated', 'Video — Haemolysis and specimen quality')]
    },
    {
      id: 'phleb-03', exam: 'phlebotomy', section: 'safety', difficulty: 'easy', type: 'mcq',
      q: 'Which vein is the first choice for routine venipuncture in the antecubital fossa?',
      opts: ['Basilic', 'Cephalic', 'Median cubital', 'Brachial'],
      a: 2,
      why: '<p>The <strong>median cubital</strong> vein is first choice: it is large, well anchored so it rolls less, close to the surface, and sits away from the brachial artery and median nerve.</p>' +
        '<p>Cephalic is the second choice. <strong>Basilic is last</strong>, precisely because the brachial artery and median nerve lie just beneath it — the risk of arterial puncture or nerve injury is highest there.</p>' +
        '<p>Brachial is an artery, not a venipuncture site at all.</p>',
      refs: [R.clsi, R.openstaxAP]
    },

    /* =====================================================================
       MEDICAL ASSISTANT
       ===================================================================== */
    {
      id: 'ma-01', exam: 'medical-assistant', section: 'clinical', difficulty: 'moderate', type: 'mcq',
      q: 'When taking a manual blood pressure, using a cuff that is too small for the patient\'s arm will produce a reading that is:',
      opts: ['Falsely low', 'Falsely high', 'Unaffected', 'Unobtainable'],
      a: 1,
      why: '<p>A cuff that is too narrow requires <strong>more pressure</strong> to compress the artery, so the reading comes out <strong>falsely high</strong>.</p>' +
        '<p>The reverse is also examinable: an oversized cuff reads falsely low.</p>' +
        '<p>The sizing rule is that the bladder width should be about <strong>40% of arm circumference</strong> and the bladder should encircle roughly 80% of the arm. Miscuffing is one of the most common sources of spurious hypertension diagnoses in practice.</p>',
      refs: [R.statpearls, yt('blood pressure cuff size error falsely high', 'Video — Cuff size and BP accuracy')]
    },
    {
      id: 'ma-02', exam: 'medical-assistant', section: 'admin', difficulty: 'moderate', type: 'mcq',
      q: 'Under HIPAA, a medical assistant may disclose protected health information without patient authorisation for which purpose?',
      opts: [
        'Sharing a diagnosis with the patient\'s employer',
        'Discussing the case with a friend who is also a nurse',
        'Submitting a claim to the patient\'s insurer for payment',
        'Posting a de-identified photo on a personal social media account'
      ],
      a: 2,
      why: '<p>HIPAA permits disclosure without separate authorisation for <strong>treatment, payment and healthcare operations</strong> — the "TPO" exception. Billing an insurer is payment.</p>' +
        '<p>Everything else listed is a violation. Employers have no automatic right to a diagnosis. Being a clinician does not grant access without a treatment relationship — that is the "minimum necessary" rule. And social media posts remain risky even when apparently de-identified, because context can re-identify a patient.</p>',
      refs: [{ t: 'HHS — Permitted Uses and Disclosures under HIPAA', u: 'https://www.hhs.gov/hipaa/for-professionals/privacy/guidance/permitted-uses/index.html', k: 'scholarly' }]
    },
    {
      id: 'ma-03', exam: 'medical-assistant', section: 'clinical', difficulty: 'moderate', type: 'mcq',
      q: 'Which injection site and needle angle are correct for an adult intramuscular deltoid injection?',
      opts: [
        '90 degrees, 1 to 1.5 inch needle, 2.5 cm below the acromion process',
        '45 degrees, 5/8 inch needle, into the upper outer arm',
        '15 degrees, 1/2 inch needle, bevel up',
        '90 degrees, 5/8 inch needle, into the anterior thigh'
      ],
      a: 0,
      why: '<p>Intramuscular injections go in at <strong>90 degrees</strong> with a needle long enough to reach muscle — typically 1 to 1.5 inches in an adult — landmarked <strong>2.5 cm (about two finger-widths) below the acromion process</strong>.</p>' +
        '<p>The other angles belong to different routes: <strong>45 degrees</strong> is subcutaneous, <strong>15 degrees bevel up</strong> is intradermal (TB testing). Option D describes the vastus lateralis, not the deltoid.</p>' +
        '<p>Landmarking matters — injecting too high risks the subacromial bursa, too low risks the radial nerve.</p>',
      refs: [{ t: 'CDC — Vaccine Administration: Route and Site', u: 'https://www.cdc.gov/vaccines/hcp/imz-best-practices/administering-vaccines.html', k: 'scholarly' }, yt('deltoid IM injection technique landmark', 'Video — Deltoid IM injection')]
    },

    /* =====================================================================
       KNAT  (Kaplan Nursing Admission Test)
       ===================================================================== */
    {
      id: 'knat-01', exam: 'kaplan-nursing', section: 'math', difficulty: 'moderate', type: 'entry',
      q: 'Convert 0.65 to a fraction in lowest terms and give the denominator.',
      a: 20, tol: 0,
      why: '<p>0.65 = 65/100. Divide both by their greatest common factor, 5: <strong>13/20</strong>.</p>' +
        '<p>So the denominator is <strong>20</strong>.</p>' +
        '<p>The check is quick: 13 is prime and does not divide 20, so the fraction cannot reduce further.</p>',
      refs: [{ t: 'Khan Academy — Decimals and fractions', u: 'https://www.khanacademy.org/math/arithmetic', k: 'reference' }]
    },
    {
      id: 'knat-02', exam: 'kaplan-nursing', section: 'science', difficulty: 'moderate', type: 'mcq',
      q: 'Which organelle is the primary site of ATP production in a eukaryotic cell?',
      opts: ['Ribosome', 'Mitochondrion', 'Golgi apparatus', 'Lysosome'],
      a: 1,
      why: '<p>The <strong>mitochondrion</strong> carries out oxidative phosphorylation, generating the large majority of a cell\'s ATP.</p>' +
        '<p>Distinguish the neighbours by job: <strong>ribosomes</strong> synthesise protein; the <strong>Golgi</strong> modifies, sorts and packages proteins for shipping; <strong>lysosomes</strong> digest waste and worn organelles.</p>' +
        '<p>Glycolysis does produce a small amount of ATP in the cytoplasm, but the yield is trivial next to the mitochondrial contribution.</p>',
      refs: [R.openstaxBio, yt('mitochondria ATP production cellular respiration', 'Video — Mitochondria and ATP')]
    },
    {
      id: 'knat-03', exam: 'kaplan-nursing', section: 'reading', difficulty: 'moderate', type: 'mcq',
      stimulus: '<p>Hospitals that adopted structured shift-handover checklists reported fewer medication errors in the following year. Supporters argue the checklist itself is responsible. Critics note that the hospitals which volunteered to adopt checklists were already investing heavily in safety training, and that error reporting systems were overhauled during the same period.</p>',
      q: 'The critics\' objection is best described as pointing out:',
      opts: [
        'That the checklists were poorly designed',
        'That other differences between the hospitals could explain the result',
        'That medication errors are not worth measuring',
        'That the study period was too short'
      ],
      a: 1,
      why: '<p>The critics raise <strong>confounding variables</strong> — the volunteering hospitals differed in other ways (existing safety investment, changed reporting systems), so the improvement cannot be attributed to the checklist alone.</p>' +
        '<p>They never claim the checklists were badly designed (A), never dismiss the outcome measure (C), and say nothing about duration (D). Each of those is a plausible-sounding criticism that simply is not in the passage.</p>' +
        '<p>Inference items reward strict textual discipline: the answer must be traceable to something actually written.</p>',
      refs: [{ t: 'Purdue OWL — Critical reading', u: 'https://owl.purdue.edu/owl/general_writing/academic_writing/index.html', k: 'reference' }]
    },

    /* =====================================================================
       NLN NEX / PAX
       ===================================================================== */
    {
      id: 'nln-01', exam: 'nln-pax', section: 'science', difficulty: 'moderate', type: 'mcq',
      q: 'In a negative feedback loop, the response to a change in a variable is to:',
      opts: [
        'Amplify the original change',
        'Oppose the original change and restore the set point',
        'Stop all further regulation',
        'Convert the variable into a different form'
      ],
      a: 1,
      why: '<p><strong>Negative feedback opposes change</strong> — that is the definition. Body temperature rises, sweating begins, temperature falls back to the set point.</p>' +
        '<p>Nearly all homeostatic control is negative feedback: blood glucose, blood pressure, osmolality, calcium.</p>' +
        '<p><strong>Positive feedback amplifies</strong>, and there are only a handful of physiological examples — oxytocin in labour, the clotting cascade, and the sodium influx of an action potential.</p>',
      refs: [R.openstaxAP, yt('negative feedback homeostasis physiology examples', 'Video — Negative vs positive feedback')]
    },
    {
      id: 'nln-02', exam: 'nln-pax', section: 'math', difficulty: 'moderate', type: 'entry',
      q: 'A patient\'s intake over a shift was 240 mL, 180 mL, and 1.2 L. What was the total intake in millilitres?',
      a: 1620, tol: 0,
      why: '<p>Convert before adding. 1.2 L = <strong>1,200 mL</strong>.</p>' +
        '<p>240 + 180 + 1,200 = <strong>1,620 mL</strong></p>' +
        '<p>Mixing units mid-calculation is the single most common error on intake-and-output items. Convert everything to the smallest unit in the problem first, then add.</p>',
      refs: [yt('intake and output calculation nursing mL conversion', 'Video — Intake and output')]
    },
    {
      id: 'nln-03', exam: 'nln-pax', section: 'verbal', difficulty: 'moderate', type: 'mcq',
      q: 'The prefix "brady-" and the suffix "-cardia" combine to mean:',
      opts: ['Fast heart rate', 'Slow heart rate', 'Irregular heart rhythm', 'Absent heartbeat'],
      a: 1,
      why: '<p><strong>Brady-</strong> means slow; <strong>-cardia</strong> refers to the heart. Bradycardia is a slow heart rate — under 60 bpm in an adult.</p>' +
        '<p>Learn the pair together: <strong>tachy-</strong> means fast, so tachycardia is over 100 bpm. The same prefixes work elsewhere: bradypnoea and tachypnoea for breathing rate.</p>' +
        '<p>Irregular rhythm is <em>dysrhythmia</em> or <em>arrhythmia</em>; absent heartbeat is <em>asystole</em>.</p>',
      refs: [{ t: 'NCBI Bookshelf — Medical terminology', u: 'https://www.ncbi.nlm.nih.gov/books/', k: 'scholarly' }]
    },

    /* =====================================================================
       FNP
       ===================================================================== */
    {
      id: 'fnp-01', exam: 'fnp', section: 'plan', difficulty: 'hard', type: 'mcq',
      q: 'A 58-year-old with newly diagnosed type 2 diabetes, an eGFR of 55 and no contraindications should be started on which first-line agent?',
      opts: ['Glipizide', 'Metformin', 'Insulin glargine', 'Pioglitazone'],
      a: 1,
      why: '<p><strong>Metformin</strong> remains first-line for type 2 diabetes. It is effective, weight-neutral, carries essentially no hypoglycaemia risk as monotherapy, and is inexpensive.</p>' +
        '<p>The renal threshold is the examinable detail: metformin may be <strong>continued down to an eGFR of 30</strong>, and should not be <em>initiated</em> below 45. At 55, initiation is appropriate.</p>' +
        '<p>Sulfonylureas such as glipizide cause hypoglycaemia and weight gain. Insulin is reserved for marked hyperglycaemia or catabolic symptoms at presentation. Pioglitazone carries fluid-retention and heart-failure concerns.</p>',
      refs: [{ t: 'ADA — Standards of Care in Diabetes', u: 'https://diabetesjournals.org/care/issue/47/Supplement_1', k: 'scholarly' }, R.statpearls]
    },
    {
      id: 'fnp-02', exam: 'fnp', section: 'assess', difficulty: 'hard', type: 'mcq',
      q: 'A 24-year-old reports a sudden severe headache described as "the worst of my life", peaking within seconds. The most appropriate next step is:',
      opts: [
        'Prescribe sumatriptan and review in one week',
        'Reassure and advise hydration and rest',
        'Immediate referral for non-contrast CT of the head',
        'Order outpatient MRI within four weeks'
      ],
      a: 2,
      why: '<p>A <strong>thunderclap headache</strong> — maximal within seconds and described as the worst ever — is subarachnoid haemorrhage until proven otherwise. That requires <strong>emergency non-contrast CT</strong>, not an outpatient pathway.</p>' +
        '<p>Sensitivity of CT is highest in the first six hours and falls steadily afterwards, which is exactly why delay is dangerous. If CT is negative and suspicion remains, lumbar puncture follows.</p>' +
        '<p>Treating this as migraine, or booking imaging weeks out, is the error the item is built to catch. The red flags worth memorising are sudden onset, worst-ever intensity, fever with neck stiffness, new headache after 50, and focal neurological deficit.</p>',
      refs: [R.statpearls, yt('thunderclap headache subarachnoid hemorrhage red flags', 'Video — Headache red flags')]
    },
    {
      id: 'fnp-03', exam: 'fnp', section: 'plan', difficulty: 'moderate', type: 'mcq',
      q: 'According to widely used guidelines, average-risk adults should begin colorectal cancer screening at age:',
      opts: ['40', '45', '50', '55'],
      a: 1,
      why: '<p>The recommended start age was lowered to <strong>45</strong> for average-risk adults, following a documented rise in colorectal cancer incidence among younger adults.</p>' +
        '<p>Acceptable modalities include colonoscopy every 10 years, annual FIT, or stool DNA testing every 1 to 3 years — patient preference matters, because the best test is the one that actually gets done.</p>' +
        '<p>Earlier screening applies to higher-risk groups: family history, inflammatory bowel disease, or genetic syndromes such as Lynch.</p>',
      refs: [{ t: 'USPSTF — Colorectal Cancer: Screening', u: 'https://www.uspreventiveservicestaskforce.org/uspstf/recommendation/colorectal-cancer-screening', k: 'scholarly' }]
    },
    {
      id: 'fnp-04', exam: 'fnp', section: 'assess', difficulty: 'moderate', type: 'mcq',
      q: 'Which finding on cardiac auscultation best localises to the mitral area?',
      opts: [
        'A murmur heard loudest at the second right intercostal space',
        'A murmur heard loudest at the fifth intercostal space, midclavicular line',
        'A murmur heard loudest at the second left intercostal space',
        'A murmur heard loudest at the left lower sternal border'
      ],
      a: 1,
      why: '<p>The <strong>mitral area</strong> is the cardiac apex — <strong>fifth intercostal space, midclavicular line</strong>. Mitral murmurs are heard best there and often radiate to the axilla.</p>' +
        '<p>The other landmarks: aortic at the second right intercostal space, pulmonic at the second left, tricuspid at the left lower sternal border.</p>' +
        '<p>"APT M" — Aortic, Pulmonic, Tricuspid, Mitral — walks you down the chest in order.</p>',
      visual: svgHeartConduction, caption: 'Cardiac anatomy orientation; auscultation landmarks follow chamber position.',
      refs: [R.openstaxAP, yt('heart auscultation landmarks aortic pulmonic tricuspid mitral', 'Video — Auscultation landmarks')]
    }
  );

})();
